import DOMPurify from "dompurify";

/**
 * @param {string} dirty - Untrusted HTML string.
 * @returns {string} Sanitized HTML safe to inject into the DOM.
 */
export const sanitizeHtml = (dirty) => DOMPurify.sanitize(dirty ?? "");

export default sanitizeHtml;
